<div class="item">
  <h2 class="value">
    @if (!isPoolLoading()) {
      {{ pool().status }}
    } @else {
      <ngx-skeleton-loader class="skeleton"></ngx-skeleton-loader>
    }
  </h2>
  <div class="divider"></div>
  <h6 class="label">{{ 'Pool Status' | translate }}</h6>
</div>
